import React, { useEffect, useState, useRef, lazy } from 'react';
import { ImageCarousel } from '../components/ImageCarousel';
import { FrustrationMethodSection } from '../components/FrustrationMethodSection';
import { AboutAuthorSection } from '../components/AboutAuthorSection';
import { FAQSection } from '../components/FAQSection';
import { useCurrency } from '../components/CurrencyContext';
import { LazySection } from '../components/LazySection';
import { UrgencyCountdown } from '../components/UrgencyCountdown';
import { GuaranteeDropdown } from '../components/GuaranteeDropdown';
import { AmazonReviewsSection } from '../components/AmazonReviewsSection';
import { FloatingCTA } from '../components/FloatingCTA';
import { CheckCircle2, StarIcon, XCircle, X, Check, Volume2 as Volume2Icon, VolumeX as VolumeXIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://recetariosaludable.lat/cart/42439418740821:1?checkout';
const HIGH_PAYING_JOBS = [{
  src: 'https://cdn.magicpatterns.com/uploads/64nEYja2c7QzMD13KEvpgu/Tablero1-scaled.jpg',
  title: 'Tablero de control industrial',
  pay: 'Trabajo típico: $800 – $2,000'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5bRgMHd1xeswMGD1zgrbX2/Different-Electrical-Contactor-Types.webp',
  title: 'Control de motores trifásicos',
  pay: 'Trabajo típico: $500 – $1,500'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7tUpAbMa8HcPM2CAnRDcq1/WhatsApp-Image-2024-05-03-at-13.33.57-3-1024x617.jpg',
  title: 'Lectura de diagramas reales',
  pay: 'Aquí es donde la mayoría falla'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1N8faA7vriCLi4UeLQj348/hone-use-electrical-wire.jpg',
  title: 'Instalaciones que requieren precisión',
  pay: 'Errores aquí = dinero perdido'
}];
function HighPayingJobsCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setCurrent(p => (p + 1) % HIGH_PAYING_JOBS.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);
  return <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4 mt-2" data-id="element-288">
      <h3 className="text-center text-[18px] md:text-[26px] font-black text-gray-900 mb-4 leading-tight font-[Poppins,_sans-serif] uppercase pt-[15px] pb-[15px]" data-id="element-289">
        👉 Estos son los trabajos donde realmente está el dinero
      </h3>
      <div className="relative overflow-hidden rounded-2xl" data-id="element-290">
        <div className="flex transition-transform duration-700 ease-in-out" style={{
        transform: `translateX(-${current * 100}%)`
      }} data-id="element-291">
          {HIGH_PAYING_JOBS.map((job, i) => <div key={i} className="flex-shrink-0 w-full px-1" data-id="element-292">
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-gray-200 overflow-hidden" data-id="element-293">
                <div className="px-4 py-3 bg-[#FFF8E1] border-b border-[#F0EBE0] text-center" data-id="element-294">
                  <p className="text-gray-900 font-bold text-[15px] md:text-[18px] leading-tight" data-id="element-295">
                    {job.title}
                  </p>
                  <p className="text-[#22C55E] font-black text-[14px] md:text-[16px] mt-1" data-id="element-296">
                    {job.pay}
                  </p>
                </div>
                <img src={job.src} alt={job.title} className="w-full h-56 md:h-72 object-cover" loading="lazy" data-id="element-297" />
              </div>
            </div>)}
        </div>
      </div>
      {/* Dots */}
      <div className="flex justify-center gap-2 mt-3" data-id="element-298">
        {HIGH_PAYING_JOBS.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === current ? 'bg-[#F5720E] scale-125' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a slide ${i + 1}`} data-id="element-299" />)}
      </div>
    </div>;
}
export function LandingPage() {
  const {
    currency,
    loading,
    formatPrice
  } = useCurrency();
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const heroVideoRef = useRef<HTMLVideoElement>(null);
  const goToCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Manual de Controles Eléctricos + Guía Práctica',
        content_type: 'product',
        value: 14.99,
        currency: 'USD'
      });
    }
    window.open(CHECKOUT_URL, '_blank');
  };
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/gvoSaTXxkxMoKNmgaHbrNJ/Guia_completa_para_sustitucion_de_ingredientes.png',
    title: 'Guía de Sustitución de Ingredientes',
    subtitle: 'Sustituye con éxito y sin renunciar al sabor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ooQ7xn6Kcd3i9RdH2HHTAX/Recetas_de_pizza_sin_gluten.png',
    title: 'Recetas de Pizza Sin Gluten',
    subtitle: 'Masa perfecta sin gluten'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7YyMXGsWB5VaeYapxfWrVs/Recetario_sin_gluten__opciones_deliciosas.png',
    title: '50 Almuerzos y Cenas Sin Gluten',
    subtitle: 'Platos deliciosos y sin riesgos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ikX66etNbDDmfmXqTRHd4c/Planificador_de_comidas_semanales_con_recetas.png',
    title: 'Planificador de Comidas Semanales',
    subtitle: 'Organiza tus comidas sin gluten'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % bonusImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bonusImages.length]);
  // Direct checkout - no cart drawer
  const toggleMute = () => {
    if (heroVideoRef.current) {
      heroVideoRef.current.muted = !heroVideoRef.current.muted;
      setIsMuted(heroVideoRef.current.muted);
    }
  };
  return <div className="min-h-screen text-gray-900 font-inter selection:bg-orange-200 bg-[#FFFF] overflow-x-clip" data-id="element-300">
      {/* ANNOUNCEMENT BAR */}
      

      {/* PROBLEM & AGITATION SECTION */}
      <LazySection data-id="element-301">
        <section className="px-4 bg-white/80 pt-0 pb-0" data-id="element-302">
          <div className="max-w-2xl mx-auto space-y-[6px]" data-id="element-303">
            {/* Subheadline highlight box */}
            <div className="mx-auto max-w-md mt-1 mb-2" data-id="element-304"></div>

            {/* Hero Headline */}
            <h1 className="text-center text-gray-900 uppercase tracking-tight md:text-[40px] px-2 pt-3 font-[600] font-[Poppins,_sans-serif] text-[12px]" data-id="element-305">
              Anunciando el Sistema Visual de Controles Eléctricos Para
              Electricistas Hispanos
            </h1>

            {/* Hero Subheadline */}
            <p className="text-center uppercase tracking-tight md:text-[20px] px-2 mt-1 font-[Poppins,_sans-serif] font-[600] text-[#F5720E] pt-[0px] pb-[0px] text-[28px]" data-id="element-306">
              +370 DIAGRAMAS Y SISTEMAS REALES LISTOS PARA USAR EN CAMPO
            </p>

            {/* Hero Image */}
            <div className="flex justify-center mb-2" data-id="element-307">
              <img src="https://cdn.magicpatterns.com/uploads/1YeXfp4JC434CwmTz9Ezek/ChatGPT_Image_May_6,_2026,_05_49_50_PM.png" alt="Sistema visual de controles eléctricos - diagramas, conexiones y tableros reales" className="w-full max-w-2xl rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)] pt-[20px] pb-[20px]" data-id="element-308" />
            </div>

            {/* AS SEEN ON Banner */}
            <div className="flex justify-center mb-3 px-4" data-id="element-309">
              <img src="https://cdn.magicpatterns.com/uploads/ryZbV2DwyR6bmkCdTPaAd3/257-2578825_m16-marketing-atlanta-web-design-company-seo-ppc-lead-seen-on-abc.png" alt="As Seen On - CBS News, ABC, NBC, FOX" className="w-full max-w-md md:max-w-lg opacity-80" loading="lazy" data-id="element-310" />
            </div>

            {/* CTA debajo de la imagen del hero */}
            <div className="flex justify-center -mt-2 mb-2 px-2" data-id="element-311"></div>

            {/* Sales Letter Intro - Desde el escritorio de Energía Rentable */}
            <div id="para-ti-section" className="mt-4 mb-4 w-full max-w-2xl mx-auto px-2 md:px-4 pt-[20px] pb-[20px]" data-id="element-312">
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-313">
                <p className="text-[13px] md:text-[14px] uppercase tracking-[0.15em] text-[#8E8E97] font-semibold mb-1 font-[Poppins,_sans-serif]" data-id="element-314">
                  Desde el escritorio deL INGENIERO Agustin Bermudez
                </p>
                <p className="text-[14px] md:text-[15px] text-gray-600 italic mb-5 font-[Poppins,_sans-serif]" data-id="element-315"></p>

                <p className="text-gray-900 font-bold text-[16px] md:text-[18px] mb-4 font-[Poppins,_sans-serif]" data-id="element-316">
                  Electricista,
                </p>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-317">
                  ¿Alguna vez te ha pasado esto?
                </p>

                <ul className="space-y-3 mb-5" data-id="element-318">
                  {['Ves un diagrama eléctrico y sientes que todo se ve confuso…', 'Te enfrentas a contactores, relés, temporizadores o motores trifásicos y no sabes por dónde empezar…', 'Has evitado trabajos porque no te sientes 100% seguro interpretando controles eléctricos…', 'Sientes que otros electricistas cobran más porque entienden sistemas que tú todavía no dominas…', 'Has buscado videos, cursos o PDFs… pero sigues sintiendo que falta una explicación clara, visual y práctica…'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-319">
                      <span className="text-[#22C55E] font-bold text-[18px] flex-shrink-0 leading-tight mt-0.5" data-id="element-320">
                        ✅
                      </span>
                      <span className="text-gray-800 text-[15px] md:text-[16px] leading-relaxed" data-id="element-321">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-322"></p>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-323">
                  Y seamos honestos…
                </p>

                <p className="text-gray-900 text-[16px] md:text-[18px] leading-relaxed mb-4 font-bold font-[Poppins,_sans-serif]" data-id="element-324">
                  Los controles eléctricos NO deberían sentirse tan complicados.
                </p>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-325">
                  Si tú quieres entender diagramas, montar controles y trabajar
                  con más seguridad…
                </p>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-326">
                  En vez de pasar meses viendo videos desordenados, copiando
                  conexiones sin entenderlas o dependiendo siempre de otro
                  electricista…
                </p>

                <div className="border-l-4 border-[#F5720E] bg-[#FFF8E1] rounded-r-lg px-4 py-3" data-id="element-327">
                  <p className="text-gray-900 text-[15px] md:text-[17px] leading-relaxed font-semibold font-[Poppins,_sans-serif]" data-id="element-328">
                    Entonces esta puede ser una de las páginas más importantes
                    que lees hoy.
                  </p>
                </div>
              </div>
            </div>

            {/* GRAN PROBLEMA - Por qué el contenido típico no funciona */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4 mt-4" data-id="element-329">
              {/* Headline destacado en banner oscuro (como la referencia) */}
              <div className="bg-[#0F1827] rounded-2xl px-6 py-10 md:py-14 mb-6 shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-330">
                <h2 className="text-center font-black text-[28px] md:text-[40px] leading-tight font-[Poppins,_sans-serif] text-white" data-id="element-331">
                  "Aquí está el{' '}
                  <span className="text-[#F7D060]" data-id="element-332">GRAN problema</span>…"
                </h2>
              </div>

              {/* Cuerpo del texto FUERA de la caja, sobre fondo limpio */}
              <div className="px-2 md:px-4" data-id="element-333">
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-334">
                  Cuando buscas aprender controles eléctricos, normalmente
                  encuentras una de estas cosas:
                </p>

                <p className="text-gray-900 text-[18px] md:text-[20px] leading-snug font-bold font-[Poppins,_sans-serif] uppercase mb-5" data-id="element-335">
                  La mayoría del contenido de electricidad en internet es{' '}
                  <span className="underline decoration-2 underline-offset-2" data-id="element-336">
                    COMPLETA BASURA.
                  </span>
                </p>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4 font-semibold" data-id="element-337">
                  Aquí está el porqué:
                </p>

                <ul className="space-y-3 mb-6" data-id="element-338">
                  {['Videos que enseñan conexiones… pero no la lógica real.', 'Cursos llenos de teoría y poca práctica real.', 'Diagramas confusos que parecen imposibles de interpretar.', 'Explicaciones que se saltan pasos importantes.', 'Contenido desordenado que te hace perder tiempo y dinero.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-339">
                      <XCircle className="w-5 h-5 text-[#DC2626] flex-shrink-0 mt-0.5" data-id="element-340" />
                      <span className="text-gray-800 text-[15px] md:text-[16px] leading-relaxed" data-id="element-341">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-342">
                  Y en muchos casos…
                </p>

                <p className="text-gray-900 font-black text-[16px] md:text-[18px] leading-relaxed mb-4 font-[Poppins,_sans-serif] uppercase" data-id="element-343">
                  Simplemente NO hay suficiente detalle.
                </p>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed" data-id="element-344">
                  Por eso tantos electricistas sienten que los controles
                  eléctricos son{' '}
                  <span className="font-bold" data-id="element-345">
                    más difíciles de lo que realmente deberían ser.
                  </span>
                </p>
              </div>
            </div>

            {/* SOLUTION INTRO - Por eso decidimos resolver todo eso */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4 mt-4" data-id="element-346">
              {/* Intro paragraph fuera de la caja */}
              <p className="text-gray-800 md:text-[17px] mb-4 px-2 md:px-4 text-[24px] font-[800] pt-[10px] pb-[10px]" data-id="element-347">
                Por eso decidimos resolver todo eso…
              </p>

              <div className="bg-white border-2 border-[#22C55E]/30 rounded-2xl p-5 md:p-8 shadow-[0_4px_20px_rgba(34,197,94,0.10)] relative overflow-hidden" data-id="element-348">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#22C55E] via-[#4ADE80] to-[#22C55E]" data-id="element-349"></div>

                <p className="text-gray-700 text-[14px] md:text-[15px] leading-relaxed mb-3" data-id="element-350">
                  Creamos la:
                </p>

                <h3 className="text-gray-900 font-black text-[22px] md:text-[30px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-351">
                  Guía Práctica de Controles Eléctricos
                </h3>

                <div className="flex justify-center mb-4" data-id="element-352">
                  <img src="https://cdn.magicpatterns.com/uploads/ecM9LkG31g3Jzuzjsuw2kX/ChatGPT_Image_5_may_2026,_07_36_24_a.m..png" alt="Comandos Eléctricos - Los 20 arrancadores de motor que todo electricista debería conocer" className="w-full max-w-2xl rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)]" loading="lazy" data-id="element-353" />
                </div>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-354">
                  Un sistema visual diseñado para ayudarte a entender controles
                  eléctricos de forma clara, práctica y aplicada al trabajo
                  REAL.
                </p>

                <div className="border-l-4 border-[#22C55E] bg-[#F0FDF4] rounded-r-lg px-4 py-3 mb-4" data-id="element-355">
                  <p className="text-gray-900 text-[15px] md:text-[17px] leading-relaxed font-bold mt-1 font-[Poppins,_sans-serif]" data-id="element-356">
                    Aprenderás a interpretar diagramas, conectar componentes y
                    comprender la lógica de los circuitos paso a paso.
                  </p>
                </div>

                <p className="text-gray-800 text-[14px] md:text-[15px] leading-relaxed mb-3 font-semibold" data-id="element-357">
                  Incluye:
                </p>

                <div className="grid grid-cols-2 gap-2" data-id="element-358">
                  {['Diagramas de fuerza', 'Conexiones realistas', 'Motores', 'Contactores', 'Relés', 'Temporizadores', 'Sensores', 'Sistemas eléctricos aplicados'].map((item, i) => <div key={i} className="flex items-start gap-2 bg-[#FFF8E1] border border-[#F0EBE0] rounded-lg px-3 py-2" data-id="element-359">
                      <CheckCircle2 className="w-4 h-4 text-[#22C55E] flex-shrink-0 mt-0.5" data-id="element-360" />
                      <span className="text-gray-800 text-[13px] md:text-[14px] leading-snug font-medium" data-id="element-361">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>

            {/* BRIDGE / CONVICTION SECTION */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4" data-id="element-362"></div>

            <div className="text-center mb-3 px-2" data-id="element-363"></div>

            {/* 👇 MIRA ESTO… heading */}
            <h3 className="text-center text-[22px] md:text-[30px] font-black text-gray-900 mt-6 mb-3 leading-tight font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-364"></h3>

            {/* DIFFERENTIATION SECTION - ¿Qué hace que este sistema sea diferente? */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4 mt-2" data-id="element-365">
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-366">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[28px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-367">
                  ¿Qué hace que este sistema sea diferente?
                </h3>

                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-368">
                  Un buen material de controles eléctricos debe tener{' '}
                  <span className="font-bold" data-id="element-369">dos cosas</span>:
                </p>

                <div className="space-y-3 mb-5" data-id="element-370">
                  <div className="flex items-start gap-3 bg-white border border-[#F0EBE0] rounded-xl px-4 py-3" data-id="element-371">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#F5720E] text-white font-black text-[14px] flex items-center justify-center" data-id="element-372">
                      1
                    </div>
                    <p className="text-gray-800 text-[15px] md:text-[16px] leading-relaxed pt-1" data-id="element-373">
                      Debe ser lo suficientemente{' '}
                      <span className="font-bold" data-id="element-374">detallado</span> para que no
                      tengas que adivinar…
                    </p>
                  </div>

                  <div className="flex items-start gap-3 bg-white border border-[#F0EBE0] rounded-xl px-4 py-3" data-id="element-375">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#22C55E] text-white font-black text-[14px] flex items-center justify-center" data-id="element-376">
                      2
                    </div>
                    <p className="text-gray-800 text-[15px] md:text-[16px] leading-relaxed pt-1" data-id="element-377">
                      Pero lo suficientemente{' '}
                      <span className="font-bold" data-id="element-378">claro</span> para que puedas
                      entenderlo sin ahogarte en teoría.
                    </p>
                  </div>
                </div>

                <div className="border-l-4 border-[#F5720E] bg-[#FFF8E1] rounded-r-lg px-4 py-3" data-id="element-379">
                  <p className="text-gray-900 text-[15px] md:text-[17px] leading-relaxed font-semibold font-[Poppins,_sans-serif]" data-id="element-380">
                    👇 Mira por qué este sistema es diferente a los cursos
                    genéricos y videos sueltos:
                  </p>
                </div>
              </div>
            </div>

            {/* === FEATURES SECTION (moved here, below diferente box) === */}
            <div className="-mx-4 my-6 bg-[#0F1827] py-6 md:py-8 px-4 rounded-2xl" data-id="element-381">
              <div className="max-w-4xl mx-auto" data-id="element-382">
                <p className="text-center text-[#FBBF24]/70 tracking-widest uppercase mb-3 text-[14px] md:text-[16px] font-[900]" data-id="element-383">
                  POR QUÉ ESTE SISTEMA ES DIFERENTE
                </p>
                <h2 className="text-center text-[22px] md:text-[34px] font-black text-white mb-2 leading-tight font-[Poppins,_sans-serif]" data-id="element-384">
                  5 RAZONES POR LAS QUE ESTO FUNCIONA
                </h2>
                <p className="text-center text-gray-400 text-sm md:text-base mb-6 max-w-xl mx-auto" data-id="element-385">
                  No es otro curso genérico. Es un sistema visual diseñado para
                  que entiendas, apliques y avances de verdad.
                </p>

                <div className="space-y-4 max-w-3xl mx-auto" data-id="element-386">
                  {/* FEATURE 01 */}
                  <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-7" data-id="element-387">
                    <span className="text-[#4F6BFF] font-black text-xs tracking-widest uppercase mb-2 block" data-id="element-388">
                      ⚡ FEATURE #1
                    </span>
                    <h3 className="text-white font-bold text-lg md:text-2xl mb-3 leading-snug font-[Poppins,_sans-serif]" data-id="element-389">
                      Diagramas explicados paso a paso
                    </h3>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-3" data-id="element-390">
                      Aquí no estás viendo imágenes sueltas sin contexto.
                      Recibes diagramas organizados para entender:
                    </p>
                    <div className="space-y-1.5 mb-3" data-id="element-391">
                      {['qué hace cada componente', 'cómo se conecta', 'por qué se conecta así', 'qué función cumple dentro del circuito', 'cómo se relaciona con el resto del sistema'].map((item, i) => <p key={i} className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-392">
                          <span className="text-[#4ADE80] flex-shrink-0" data-id="element-393">
                            ✅
                          </span>
                          <span data-id="element-394">{item}</span>
                        </p>)}
                    </div>
                    <p className="text-[#4ADE80]/80 text-xs md:text-sm font-semibold italic" data-id="element-395">
                      Es como tener una guía visual al lado mientras estudias
                      cada control.
                    </p>
                  </div>

                  {/* FEATURE 02 */}
                  <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-7" data-id="element-396">
                    <span className="text-[#FBBF24] font-black text-xs tracking-widest uppercase mb-2 block" data-id="element-397">
                      🔌 FEATURE #2
                    </span>
                    <h3 className="text-white font-bold text-lg md:text-2xl mb-3 leading-snug font-[Poppins,_sans-serif]" data-id="element-398">
                      Diagramas de fuerza y control
                    </h3>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-3" data-id="element-399">
                      Uno de los errores más comunes es mezclarlo todo y
                      terminar más confundido. Por eso este sistema muestra la
                      diferencia entre:
                    </p>
                    <div className="space-y-1.5 mb-3" data-id="element-400">
                      {['circuito de fuerza', 'circuito de control', 'conexión realista', 'símbolos eléctricos', 'componentes físicos'].map((item, i) => <p key={i} className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-401">
                          <span className="text-[#4ADE80] flex-shrink-0" data-id="element-402">
                            ✅
                          </span>
                          <span data-id="element-403">{item}</span>
                        </p>)}
                    </div>
                    <p className="text-[#4ADE80]/80 text-xs md:text-sm font-semibold italic" data-id="element-404">
                      Así puedes entender cómo se ve el sistema en papel y cómo
                      se aplica en la vida real.
                    </p>
                  </div>

                  {/* FEATURE 03 */}
                  <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-7" data-id="element-405">
                    <span className="text-[#F97316] font-black text-xs tracking-widest uppercase mb-2 block" data-id="element-406">
                      🏭 FEATURE #3
                    </span>
                    <h3 className="text-white font-bold text-lg md:text-2xl mb-3 leading-snug font-[Poppins,_sans-serif]" data-id="element-407">
                      Conexiones realistas y aplicaciones industriales
                    </h3>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-3" data-id="element-408">
                      Aquí no solo ves teoría. Ves aplicaciones como:
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 mb-3" data-id="element-409">
                      {['arranques eléctricos', 'motores monofásicos', 'motores trifásicos', 'contactores', 'relés térmicos', 'temporizadores', 'señalización', 'sensores', 'protecciones', 'tableros de control'].map((item, i) => <p key={i} className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-410">
                          <span className="text-[#4ADE80] flex-shrink-0" data-id="element-411">
                            ✅
                          </span>
                          <span data-id="element-412">{item}</span>
                        </p>)}
                    </div>
                    <p className="text-[#4ADE80]/80 text-xs md:text-sm font-semibold italic" data-id="element-413">
                      Esto es lo que hace que el aprendizaje se sienta más real,
                      más visual y más aplicable.
                    </p>
                  </div>

                  {/* FEATURE 04 */}
                  <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-7" data-id="element-414">
                    <span className="text-[#A78BFA] font-black text-xs tracking-widest uppercase mb-2 block" data-id="element-415">
                      🎯 FEATURE #4
                    </span>
                    <h3 className="text-white font-bold text-lg md:text-2xl mb-3 leading-snug font-[Poppins,_sans-serif]" data-id="element-416">
                      Sin adivinar conexiones
                    </h3>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-3" data-id="element-417">
                      Con diagramas claros y explicaciones visuales, reduces la
                      sensación de estar "adivinando" qué cable va dónde o qué
                      función tiene cada parte del circuito.
                    </p>
                    <div className="border-l-2 border-[#4ADE80]/40 pl-4 space-y-1.5" data-id="element-418">
                      <p className="text-gray-300 text-sm md:text-base" data-id="element-419">
                        Cuando el material es claro, todo empieza a tener
                        sentido.
                      </p>
                      <p className="text-gray-300 text-sm md:text-base" data-id="element-420">
                        Las piezas empiezan a encajar.
                      </p>
                      <p className="text-white font-semibold text-sm md:text-base" data-id="element-421">
                        Y lo que antes parecía complicado, comienza a verse
                        lógico.
                      </p>
                    </div>
                  </div>

                  {/* FEATURE 05 */}
                  <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-7" data-id="element-422">
                    <span className="text-[#22C55E] font-black text-xs tracking-widest uppercase mb-2 block" data-id="element-423">
                      👥 FEATURE #5
                    </span>
                    <h3 className="text-white font-bold text-lg md:text-2xl mb-3 leading-snug font-[Poppins,_sans-serif]" data-id="element-424">
                      Diseñado para principiantes, técnicos y electricistas con
                      experiencia
                    </h3>
                    <div className="space-y-1.5 mb-3" data-id="element-425">
                      <p className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-426">
                        <span className="text-[#F97316] flex-shrink-0" data-id="element-427">❌</span>
                        <span data-id="element-428">No necesitas ser ingeniero.</span>
                      </p>
                      <p className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-429">
                        <span className="text-[#F97316] flex-shrink-0" data-id="element-430">❌</span>
                        <span data-id="element-431">
                          No necesitas dominar automatización avanzada.
                        </span>
                      </p>
                      <p className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-432">
                        <span className="text-[#F97316] flex-shrink-0" data-id="element-433">❌</span>
                        <span data-id="element-434">
                          No necesitas años de experiencia en controles.
                        </span>
                      </p>
                    </div>
                    <p className="text-white font-semibold text-sm md:text-base mb-2" data-id="element-435">
                      Este sistema es para ti si:
                    </p>
                    <div className="space-y-1.5" data-id="element-436">
                      {['estás empezando', 'eres electricista residencial y quieres subir de nivel', 'estudias electricidad', 'ya trabajas en el área pero te falta seguridad', 'quieres entender controles eléctricos de forma más práctica'].map((item, i) => <p key={i} className="text-gray-300 text-sm md:text-base flex items-start gap-2" data-id="element-437">
                          <span className="text-[#4ADE80] flex-shrink-0" data-id="element-438">
                            ✅
                          </span>
                          <span data-id="element-439">{item}</span>
                        </p>)}
                    </div>
                  </div>
                </div>

                {/* +370 PAGES SUMMARY */}
                <div className="mt-6 max-w-3xl mx-auto bg-gradient-to-br from-[#1A2332] to-[#0F1827] border-2 border-[#F5720E]/40 rounded-2xl p-5 md:p-8 shadow-[0_8px_30px_rgba(245,114,14,0.15)]" data-id="element-440">
                  <p className="text-[#F5720E] font-black text-xs md:text-sm tracking-widest uppercase mb-2" data-id="element-441">
                    📚 BIBLIOTECA VISUAL COMPLETA
                  </p>
                  <h3 className="text-white font-black text-2xl md:text-3xl mb-3 leading-tight font-[Poppins,_sans-serif]" data-id="element-442">
                    Más de 370 páginas de contenido visual
                  </h3>
                  <p className="text-gray-300 text-sm md:text-base mb-4" data-id="element-443">
                    Dentro de la guía encontrarás:
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 mb-4" data-id="element-444">
                    {['diagramas eléctricos', 'diagramas de control', 'diagramas de fuerza', 'conexiones realistas', 'motores eléctricos', 'contactores', 'relés térmicos', 'temporizadores', 'sensores', 'sistemas automáticos', 'señalización', 'protección eléctrica', 'ejemplos industriales reales'].map((item, i) => <p key={i} className="text-gray-200 text-sm md:text-base flex items-start gap-2" data-id="element-445">
                        <span className="text-[#4ADE80] flex-shrink-0" data-id="element-446">✅</span>
                        <span data-id="element-447">{item}</span>
                      </p>)}
                  </div>
                  <p className="text-[#FBBF24] font-bold text-sm md:text-base italic" data-id="element-448">
                    Y mucho más.
                  </p>
                </div>

                {/* CTA */}
                <div className="mt-6 text-center max-w-xl mx-auto" data-id="element-449">
                  <button onClick={goToCheckout} className="green-cta-impact w-full max-w-md mx-auto text-white font-black py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55E] font-[Roboto,_sans-serif] flex flex-col items-center gap-1" data-id="element-450">
                    <span className="text-[18px] md:text-[20px] uppercase tracking-wide" data-id="element-451">
                      SÍ, QUIERO ACCESO INMEDIATO
                    </span>
                    <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-452">
                      Acceso Inmediato • Garantía de 7 Días
                    </span>
                  </button>
                  <p className="text-gray-500 text-xs mt-2 tracking-wide" data-id="element-453">
                    Acceso inmediato • Sin complicaciones • Todo en un solo
                    lugar
                  </p>
                </div>
              </div>
            </div>

            {/* === SALTO PROFESIONAL + NO IMPORTA SI TE SIENTES PERDIDO === */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mt-6 mb-4 space-y-5" data-id="element-454">
              {/* SALTO PROFESIONAL */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-455">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[28px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-456">
                  Los trabajos mejor pagados normalmente requieren esto
                </h3>
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3 font-semibold" data-id="element-457">
                  Seamos directos:
                </p>
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-458">
                  Muchos electricistas se quedan haciendo trabajos básicos
                  porque nunca dieron el salto a entender controles eléctricos.
                </p>
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-459">
                  Y los controles eléctricos son una habilidad que puede
                  ayudarte a verte más profesional, aceptar trabajos más
                  avanzados y sentirte más seguro frente a sistemas reales.
                </p>
                <div className="border-l-4 border-[#F5720E] bg-[#FFF8E1] rounded-r-lg px-4 py-3" data-id="element-460">
                  <p className="text-gray-900 text-[15px] md:text-[17px] leading-relaxed font-[Poppins,_sans-serif]" data-id="element-461">
                    Porque un electricista que entiende diagramas…
                  </p>
                  <p className="text-gray-900 text-[15px] md:text-[17px] leading-relaxed font-bold mt-1 font-[Poppins,_sans-serif]" data-id="element-462">
                    No trabaja igual que uno que solo copia conexiones.
                  </p>
                </div>
              </div>

              {/* NO IMPORTA SI TE SIENTES PERDIDO */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-463">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[26px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-464">
                  No importa si ahora te sientes perdido
                </h3>
                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-465">
                  Tal vez piensas:
                </p>
                <div className="bg-gray-100 border-l-4 border-gray-400 rounded-r-lg px-4 py-3 mb-4" data-id="element-466">
                  <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed italic" data-id="element-467">
                    Esto es muy avanzado para mí…
                  </p>
                </div>
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-468">
                  Pero la verdad es que muchas veces{' '}
                  <span className="font-bold" data-id="element-469">el problema no eres tú</span>.
                </p>
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-470">
                  El problema es que nadie te lo explicó de forma clara.
                </p>
                <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-471">
                  La mayoría del contenido te tira teoría encima.
                </p>
                <p className="text-gray-900 text-[16px] md:text-[18px] leading-relaxed font-bold font-[Poppins,_sans-serif]" data-id="element-472">
                  Este sistema te muestra el contenido de forma visual, práctica
                  y ordenada. Paso a paso.
                </p>
              </div>

              {/* ESTO ES TODO LO QUE RECIBES HOY - VALUE STACK */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-473">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[28px] leading-tight mb-5 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-474">
                  Esto es todo lo que recibes hoy
                </h3>

                <ul className="space-y-3" data-id="element-475">
                  {[{
                  title: 'Guía Práctica de Controles Eléctricos',
                  desc: 'Más de 370 páginas visuales con diagramas, conexiones y sistemas explicados paso a paso.',
                  value: '$97'
                }, {
                  title: 'Diagramas de fuerza y control',
                  desc: 'Para entender cómo funciona cada sistema desde la lógica eléctrica.',
                  value: '$47'
                }, {
                  title: 'Conexiones realistas',
                  desc: 'Para ver cómo se aplica el diagrama en componentes reales.',
                  value: '$37'
                }, {
                  title: 'Ejemplos de motores, contactores, relés y temporizadores',
                  desc: 'Para estudiar sistemas que se usan en trabajos reales.',
                  value: '$47'
                }, {
                  title: 'Acceso inmediato digital',
                  desc: 'Puedes empezar a revisar el material desde tu celular, tablet o computadora.',
                  value: '$27'
                }].map((item, i) => <li key={i} className="flex items-start gap-3 bg-white border border-[#F0EBE0] rounded-xl px-4 py-3" data-id="element-476">
                      <CheckCircle2 className="w-5 h-5 text-[#22C55E] flex-shrink-0 mt-1" data-id="element-477" />
                      <div className="flex-1 min-w-0" data-id="element-478">
                        <p className="text-gray-900 font-bold text-[15px] md:text-[17px] leading-snug font-[Poppins,_sans-serif]" data-id="element-479">
                          {item.title}
                        </p>
                        <p className="text-gray-700 text-[14px] md:text-[15px] leading-relaxed mt-1" data-id="element-480">
                          {item.desc}
                        </p>
                        <p className="text-[#F5720E] font-black text-[14px] md:text-[15px] mt-1.5" data-id="element-481">
                          Valor:{' '}
                          <span className="text-[#22C55E]" data-id="element-482">{item.value}</span>
                        </p>
                      </div>
                    </li>)}
                </ul>
              </div>

              {/* BONOS + PRICE REVEAL + CTA */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-483">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[28px] leading-tight mb-5 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-484">
                  Además, si entras hoy, recibes estos bonos
                </h3>

                <ul className="space-y-3 mb-6" data-id="element-485">
                  {[{
                  n: '#1',
                  title: 'Simulaciones y escenarios reales',
                  desc: 'Practica con situaciones visuales antes de enfrentarte a trabajos reales.',
                  value: '$47'
                }, {
                  n: '#2',
                  title: 'Diagramas industriales adicionales',
                  desc: 'Más ejemplos para seguir entendiendo controles eléctricos paso a paso.',
                  value: '$37'
                }, {
                  n: '#3',
                  title: 'Biblioteca extra de conexiones eléctricas',
                  desc: 'Material adicional para estudiar conexiones, componentes y sistemas.',
                  value: '$27'
                }, {
                  n: '#4',
                  title: 'Actualizaciones futuras',
                  desc: 'A medida que el sistema se actualice, podrás recibir nuevo contenido y mejoras.',
                  value: '$67'
                }].map((item, i) => <li key={i} className="flex items-start gap-3 bg-white border border-[#F0EBE0] rounded-xl px-4 py-3" data-id="element-486">
                      <div className="flex-shrink-0 inline-flex items-center justify-center bg-[#F5720E] text-white font-black text-[12px] px-2.5 py-1 rounded-md uppercase tracking-wide" data-id="element-487">
                        Bono {item.n}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-488">
                        <p className="text-gray-900 font-bold text-[15px] md:text-[17px] leading-snug font-[Poppins,_sans-serif]" data-id="element-489">
                          {item.title}
                        </p>
                        <p className="text-gray-700 text-[14px] md:text-[15px] leading-relaxed mt-1" data-id="element-490">
                          {item.desc}
                        </p>
                        <p className="text-[#F5720E] font-black text-[14px] md:text-[15px] mt-1.5" data-id="element-491">
                          Valor:{' '}
                          <span className="text-[#22C55E]" data-id="element-492">{item.value}</span>
                        </p>
                      </div>
                    </li>)}
                </ul>

                {/* PRICE REVEAL */}
                <div className="bg-white border-2 border-[#F5720E]/30 rounded-2xl p-5 md:p-6 text-center mb-5 shadow-[0_4px_20px_rgba(245,114,14,0.10)]" data-id="element-493">
                  <p className="text-gray-700 text-[14px] md:text-[15px] uppercase tracking-widest font-semibold mb-1" data-id="element-494">
                    Valor total
                  </p>
                  <p className="text-[#F5720E] font-black text-[28px] md:text-[36px] leading-none mb-4 font-[Poppins,_sans-serif]" data-id="element-495">
                    $359+
                  </p>

                  <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-2" data-id="element-496">
                    Pero hoy no vas a pagar{' '}
                    <span className="line-through text-gray-500" data-id="element-497">$359</span>.
                  </p>
                  <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-2" data-id="element-498">
                    Ni <span className="line-through text-gray-500" data-id="element-499">$197</span>.
                  </p>
                  <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-500">
                    Ni <span className="line-through text-gray-500" data-id="element-501">$97</span>.
                  </p>

                  <p className="text-gray-700 text-[15px] md:text-[16px] mb-1" data-id="element-502">
                    Hoy puedes acceder por solo:
                  </p>
                  <p className="text-[#22C55E] font-black text-[44px] md:text-[60px] leading-none my-2 font-[Poppins,_sans-serif]" data-id="element-503">
                    $19.99
                  </p>
                </div>

                {/* CTA */}
                <button onClick={goToCheckout} className="green-cta-impact w-full text-white font-black py-5 px-6 rounded-2xl cursor-pointer bg-[#22C55E] flex flex-col items-center gap-1" data-id="element-504">
                  <span className="text-[18px] md:text-[20px] uppercase tracking-wide" data-id="element-505">
                    ACCEDER AL SISTEMA AHORA
                  </span>
                  <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-506">
                    Acceso Inmediato • Garantía de 7 Días
                  </span>
                </button>
                <p className="text-gray-600 text-[13px] md:text-[14px] text-center mt-3 font-medium" data-id="element-507">
                  Pago único. Acceso inmediato. Sin mensualidades.
                </p>
              </div>
            </div>

            {/* Identification Heading */}

            {/* Video Testimonials (Luis Ramírez & Francisco Javier) */}
            <div className="flex flex-col gap-4 mb-6 w-full max-w-md mx-auto px-2" data-id="element-508">
              {/* Video 1 - Luis Ramírez */}
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-4 flex flex-col items-center text-center pt-[15px] pb-[15px]" data-id="element-509">
                <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-3 bg-black" data-id="element-510">
                  <video src="https://cdn.magicpatterns.com/uploads/9i11Vjyfiyk1yw5VqYEhgN/undefined - Imgur (1).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="metadata" data-id="element-511" />
                </div>
                <div className="flex gap-1 mb-2" data-id="element-512">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-513" />)}
                </div>
                <h4 className="text-[20px] font-bold text-gray-900 mb-0.5" data-id="element-514">
                  Luis Ramírez
                </h4>
                <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-2" data-id="element-515">
                  Técnico Electricista
                </p>
                <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-516">
                  "Ahora puedo realizar mis propios proyectos sin depender de
                  nadie y ganar más."
                </p>
              </div>

              {/* Video 2 - Francisco Javier */}
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-4 flex flex-col items-center text-center" data-id="element-517">
                <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-3 bg-black" data-id="element-518">
                  <video src="https://cdn.magicpatterns.com/uploads/wnbQ9Bgc4WFeND59VotTcs/undefined - Imgur (2).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="metadata" data-id="element-519" />
                </div>
                <div className="flex gap-1 mb-2" data-id="element-520">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-521" />)}
                </div>
                <h4 className="text-[20px] font-bold text-gray-900 mb-0.5" data-id="element-522">
                  Francisco Javier
                </h4>
                <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-2" data-id="element-523">
                  Electricista Independiente
                </p>
                <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-524">
                  "Este sistema me dio la confianza para tomar trabajos que
                  antes rechazaba."
                </p>
              </div>

              {/* Amazon-Style Reviews Section - moved below Francisco Javier */}
              <AmazonReviewsSection data-id="element-525" />
            </div>

            {/* Product Mockup Image */}
            <div className="flex justify-center mb-4" data-id="element-526">
              
            </div>

            {/* Identification Card */}
            

            {/* Image Carousel - moved here, right below "Esto es exactamente lo que vas a usar" */}
            <div className="pt-2 md:pt-4 bg-white/80" data-id="element-527">
              <h2 className="md:text-4xl font-black text-gray-900 uppercase tracking-tight text-center px-4 mb-3 md:mb-4 text-[16px]" data-id="element-528">
                👉 370+ páginas a color accesibles desde cualquier dispositivo
                Celular, tablet o laptop — aprende donde quieras.
              </h2>
              <ImageCarousel data-id="element-529" />
            </div>

            {/* === MOVED: Investment Reframe Box (caja de oferta validada) === */}
            <div className="max-w-lg mx-auto mt-2 mb-4" data-id="element-530">
              
            </div>

            {/* === MOVED: OFERTA PROMOCIONAL (caja del producto y precio) === */}
            <div className="max-w-4xl mx-auto py-4" data-id="element-531">
              <div id="oferta-conviccion" className="bg-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.15)] overflow-hidden" data-id="element-532">
                <div className="flex flex-col md:flex-row" data-id="element-533">
                  {/* LEFT: Product Image */}
                  <div className="md:w-1/2 p-4 md:p-6 flex flex-col items-center justify-center bg-[#FAFAFA]" data-id="element-534">
                    <div className="relative w-full max-w-sm" data-id="element-535">
                      <div className="absolute -top-3 -right-3 z-10 text-white text-[11px] font-black px-3 py-1.5 rounded-lg shadow-[0_3px_10px_rgba(255,107,0,0.4)] rotate-[8deg] uppercase tracking-wider border-2 border-white bg-[#F49B42]" data-id="element-536">
                        ⭐ Best Seller
                      </div>
                      <img src="https://cdn.magicpatterns.com/uploads/gpQcdGR9pb7tp62jigKpwF/8PXa8N2.png" alt="Sistema completo de Comandos Eléctricos - Todos los bonos incluidos" className="w-full rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.12)]" loading="lazy" data-id="element-537" />
                      <div className="absolute -bottom-3 -right-3 z-10 bg-[#2563EB] text-white text-[11px] font-black px-3 py-1.5 rounded-lg shadow-[0_3px_10px_rgba(37,99,235,0.4)] -rotate-[6deg] uppercase tracking-wider border-2 border-white flex items-center gap-1" data-id="element-538">
                        🎬 +150 Videos
                      </div>
                    </div>
                    <div className="mt-3 text-left px-2" data-id="element-539">
                      <p className="font-bold tracking-[0.2em] uppercase mb-1 text-[12px] text-[#8E8E97]" data-id="element-540">
                        +5.478 DESCARGAS
                      </p>
                      <h3 className="text-[#111111] md:text-[28px] font-black uppercase tracking-tight text-[20px]" data-id="element-541">
                        Comandos Eléctricos PRO + Certificación Profesional ( 8
                        bonos gratis)
                      </h3>
                      <span className="inline-flex items-center gap-1 bg-[#DC2626] text-white text-[11px] font-bold px-2.5 py-1 rounded-md mt-1" data-id="element-542">
                        🎁 Oferta +50% OFF · solo 20 cupos
                      </span>

                      <div className="mt-3" data-id="element-543">
                        <p className="text-[#E53935] font-bold md:text-[24px] text-[24px]" data-id="element-544">
                          SOLO POR HOY $14.99
                        </p>
                        <p className="md:text-[14px] mt-1 opacity-70 text-[14px] text-[#0E0D0D]" data-id="element-545">
                          Antes <span className="line-through" data-id="element-546">$97</span> —
                          descuento activo hoy
                        </p>
                        <p className="text-[#999] text-[12px] mt-1" data-id="element-547">
                          💳 Pago único • Acceso inmediato
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT: Sales Content */}
                  <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center" data-id="element-548">
                    <button id="cta-comprar-1clic" onClick={goToCheckout} className="green-cta-impact w-full text-white font-black py-5 px-6 rounded-xl mb-4 cursor-pointer bg-[#22C55F] flex flex-col items-center gap-1" data-id="element-549">
                      <span className="text-[18px] md:text-[20px] uppercase tracking-wide" data-id="element-550">
                        SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
                      </span>
                      <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-551">
                        Acceso Inmediato • Garantía de 7 Días
                      </span>
                    </button>

                    <div className="mb-2" data-id="element-552">
                      <UrgencyCountdown data-id="element-553" />
                    </div>

                    <p className="text-[#6b7280] text-xs text-center mb-3" data-id="element-554">
                      Acceso inmediato • Pago único • Sin suscripciones
                    </p>

                    <div className="flex justify-center" data-id="element-555">
                      <img src="https://cdn.magicpatterns.com/uploads/p6qxTwGmZgbzY9XkZUWTq8/Trust-badges.webp" alt="Guaranteed Safe Checkout" className="max-w-[240px] w-full opacity-80" loading="lazy" data-id="element-556" />
                    </div>
                  </div>
                </div>
              </div>

              <GuaranteeDropdown data-id="element-557" />
            </div>
          </div>
        </section>
      </LazySection>

      {/* VIDEO TESTIMONIALS + FRUSTRATION METHOD */}
      <LazySection data-id="element-558">
        <section className="px-4 bg-white/80 py-4" data-id="element-559">
          <div className="max-w-2xl mx-auto" data-id="element-560">
            {/* Video Testimonials */}

            <FrustrationMethodSection data-id="element-561" />
          </div>
        </section>
      </LazySection>

      {/* HERO SECTION */}
      <LazySection data-id="element-562">
        <section className="px-4 bg-[#FFFBEB] py-1 mt-0 mb-0" data-id="element-563">
          <div className="max-w-2xl mx-auto" data-id="element-564">
            <div className="flex justify-center mt-1" data-id="element-565">
              <img src="https://cdn.magicpatterns.com/uploads/1Ma4sTrAHUAYdaEPN8LkAw/30-day-money-back-guarantee-260nw-2631258675.webp" alt="Garantía de devolución de dinero - 7, 10, 15 y 30 días" className="max-w-[200px] w-full opacity-70" loading="lazy" style={{
              mixBlendMode: 'multiply'
            }} data-id="element-566" />
            </div>
            {/* GIF */}
            <div className="flex justify-center mt-2" data-id="element-567">
              
            </div>
          </div>
        </section>
      </LazySection>

      {/* GUARANTEE BADGE */}
      <LazySection data-id="element-568">
        <section className="py-6 px-4 bg-[#FFFBEB]" data-id="element-569">
          <div className="max-w-lg mx-auto" data-id="element-570">
            <div className="bg-white rounded-2xl shadow-[0_2px_20px_rgba(0,0,0,0.06)] border border-[#F0EBE0] p-6 md:p-8 text-center" data-id="element-571">
              {/* Badge Circle */}
              <div className="mx-auto mb-4 w-28 h-28 rounded-full bg-gradient-to-b from-[#F7D060] to-[#D9A441] flex flex-col items-center justify-center shadow-[0_4px_16px_rgba(217,164,65,0.3)] border-4 border-[#C8A84E]" data-id="element-572">
                <span className="text-[36px] font-black text-gray-900 leading-none" data-id="element-573">
                  7
                </span>
                <span className="text-[11px] font-bold text-gray-800 uppercase tracking-wider" data-id="element-574">
                  Días
                </span>
                <span className="bg-gray-900 text-[#F7D060] text-[9px] font-black px-3 py-0.5 rounded-sm uppercase tracking-widest mt-0.5" data-id="element-575">
                  Garantía
                </span>
              </div>

              {/* Title */}
              <h3 className="md:text-2xl font-black text-gray-900 mb-3 text-[24px] font-[Inter,_sans-serif]" data-id="element-576">
                Pruebalo durante 7 dias
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-2" data-id="element-577">
                No quiero tu dinero si este manual no transforma tu cocina. Por
                eso te doy mi{' '}
                <span className="font-bold text-gray-900" data-id="element-578">
                  Garantía Blindada de 7 Días
                </span>
                .
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3" data-id="element-579">
                Si sentís que no es para vos, nos enviás un correo y te
                devolvemos el{' '}
                <span className="font-bold text-gray-900" data-id="element-580">
                  100% de tu inversión
                </span>
                . Sin preguntas, sin vueltas.
              </p>

              {/* Closing line */}
              <p className="text-[#D9A441] font-bold text-sm md:text-base italic" data-id="element-581">
                — El riesgo es todo nuestro.
              </p>
            </div>
          </div>
        </section>
      </LazySection>

      <LazySection data-id="element-582">
        <AboutAuthorSection data-id="element-583" />
      </LazySection>

      <LazySection data-id="element-584">
        <FAQSection data-id="element-585" />
      </LazySection>

      {/* URGENCY & FINAL CLOSE */}
      <LazySection data-id="element-586">
        <div className="py-6 px-4 bg-[#0F1827] text-center" data-id="element-587">
          <div className="max-w-md mx-auto" data-id="element-588">
            <p className="text-white md:text-lg font-bold mb-3 text-[14px]" data-id="element-589">
              No dejes pasar esta oportunidad
            </p>
            <button onClick={goToCheckout} className="green-cta-impact w-full text-white py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55F] font-[900] font-[Inter,_sans-serif] flex flex-col items-center gap-1" data-id="element-590">
              <span className="text-[20px] md:text-[22px] uppercase tracking-wide" data-id="element-591">
                SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
              </span>
              <span className="text-[13px] md:text-[14px] font-semibold opacity-90" data-id="element-592">
                Acceso Inmediato • Garantía de 7 Días
              </span>
            </button>
            <p className="text-gray-500 text-xs mt-2 tracking-wide" data-id="element-593">
              Acceso inmediato • Sin pagos mensuales • Empiezas en segundos
            </p>
          </div>
        </div>
      </LazySection>

      {/* Floating CTA Button */}
      <FloatingCTA data-id="element-594" />

      {/* Footer */}
      <LazySection data-id="element-595">
        <footer className="bg-[#0F1827] py-5 px-4 text-center" data-id="element-596">
          <p className="text-gray-400 text-sm" data-id="element-597">
            📧 Contacto:{' '}
            <a href="mailto:apoyocomunidadelectrica@gmail.com" className="text-[#F7D060] hover:underline font-medium" data-id="element-598">
              apoyocomunidadelectrica@gmail.com
            </a>
          </p>
          <p className="text-gray-500 text-xs mt-2" data-id="element-599">
            © {new Date().getFullYear()} Comunidad Eléctrica. Todos los
            derechos reservados.
          </p>
        </footer>
      </LazySection>
    </div>;
}